import axios from 'axios'
import Dialog from 'lib/components/Dialog/Dialog'
import AuthContext from 'lib/context/AuthContext'
import { reportError } from 'lib/util/errorHandler'
import ActionDialog from 'pages/Home/admin/ActionDialog/ActionDialog'
import RecordedWebinarType from 'pages/Home/RecordedWebinarType'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface DeleteRecordedWebinarDialogProps {
  recordedWebinar: RecordedWebinarType
  onRequestClose: ()=> void
}

export default function DeleteRecordedWebinarDialog(props: DeleteRecordedWebinarDialogProps) {
  const { onRequestClose, recordedWebinar } = props
  const [t] = useTranslation()
  const { getAccessToken } = useContext(AuthContext)
  const [apiState, setApiState] = useState({ saving: false, error: null })

  async function deleteRecordedWebinar() {
    setApiState({ error: null, saving: true })
    try {
      const accessToken = await getAccessToken()
      const headers = { Authorization: `Bearer ${accessToken}` }
      await axios.delete(`${process.env.THREESIXTY_TRAINING_URI}/admin/recorded-webinars/${recordedWebinar.id}`, {
        headers
      })
      window.location.reload()
    } catch (err) {
      if (err.response && err.response.status === 409) {
        return setApiState({ error: t('home.recordedWebinarsSection.admin.deleteDialog.conflictError'), saving: false })
      }
      setApiState({ error: t('home.recordedWebinarsSection.admin.deleteDialog.apiError'), saving: false })
      reportError(err, 'Error deleting recorded webinar', { recordedWebinarId: recordedWebinar.id })
    }
  }

  const { error, saving } = apiState

  return (
    <Dialog type="warning" onRequestClose={onRequestClose}>
      <Dialog.Header onRequestClose={onRequestClose}>
        <Dialog.Title>{t('home.recordedWebinarsSection.admin.deleteDialog.header')}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>{t('home.recordedWebinarsSection.admin.deleteDialog.body')}</Dialog.Body>
      <ActionDialog.Footer>
        <div>
          <ActionDialog.CancelButton onClick={onRequestClose} />
          <ActionDialog.DeleteButton loading={saving} onClick={deleteRecordedWebinar} />
        </div>
        <ActionDialog.Error message={error} />
      </ActionDialog.Footer>
    </Dialog>
  )
}
